export default "__VITE_ASSET__rszYzol5__"